import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { ICompanyDataModel } from '../../data-models/company.data-model';
import { sectorsAtom } from '../../services/state/AppConfigStateJ';
import { SAMPLE_COMPANIES } from './sample-companies';

/** Sample companies spread across the tenant's own sectors, so sector columns and filters read like theirs. */
export function useSampleCompanies(base: ICompanyDataModel[] = SAMPLE_COMPANIES): ICompanyDataModel[] {
  const sectors = useAtomValue(sectorsAtom);
  return useMemo(
    () =>
      base.map((company, index) => ({
        ...company,
        sectorId: sectors.length ? sectors[index % sectors.length].id : null,
      })),
    [base, sectors]
  );
}
